import {
  getAdvertisersFromClients,
  getAdvertisersFromWhitelabels,
  sortAdvertisersByLabels,
} from '@/helpers/advertisers';
import { mergeSegmentsAndAdvertisers } from '@/helpers/pixels';
import { RootState } from '@/store';
import { createSelector } from '@reduxjs/toolkit';
import { selectHideWhitelabels } from './me.selectors';
import {
  selectRibeyeWithBeeswaxClients,
  selectRibeyeWithBeeswaxWhitelabels,
  selectSharedApiLoading,
} from './sharedApi.selectors';

export const selectPixels = (state: RootState) => state.pixels;

export const selectLoadingPage = createSelector(
  [selectPixels, selectSharedApiLoading],
  ({ pixelsRequestId, segmentsRequestId, activeStatusRequestId }, sharedApiLoading) =>
    !!(pixelsRequestId || segmentsRequestId || activeStatusRequestId || sharedApiLoading),
);

export const selectLoadingPixels = createSelector(
  [selectPixels],
  ({ pixelsRequestId, pixelsReportRequestId }) => !!(pixelsRequestId || pixelsReportRequestId),
);

export const selectPixelsSegments = createSelector([selectPixels], ({ segments, segmentsRequestId }) => ({
  segments,
  loadingSegments: !!segmentsRequestId,
}));

export const selectSelectedPixel = createSelector(
  [selectPixels],
  ({ selectedPixel, selectedPixelTag, selectedPixelTagRequestId }) => ({
    selectedPixel,
    selectedPixelTag,
    selectedPixelTagLoading: !!selectedPixelTagRequestId,
  }),
);

export const selectPixelsFilters = createSelector([selectPixels], ({ filters }) => filters);

export const selectPixelsAdvertisers = createSelector(
  [
    selectRibeyeWithBeeswaxWhitelabels,
    selectRibeyeWithBeeswaxClients,
    selectPixelsSegments,
    selectSharedApiLoading,
    selectHideWhitelabels,
  ],
  (whitelabels, clients, { segments, loadingSegments }, loading, hideWhitelabels) => {
    if (loading) {
      return [];
    }
    const advertisers = hideWhitelabels
      ? getAdvertisersFromClients(clients || [])
      : getAdvertisersFromWhitelabels(whitelabels || []);

    if (loadingSegments) {
      return sortAdvertisersByLabels(advertisers);
    }

    return sortAdvertisersByLabels(mergeSegmentsAndAdvertisers(segments, advertisers));
  },
);

export const selectPixelsReport = createSelector([selectPixels], ({ pixelsReport, pixelsReportRequestId }) => ({
  report: pixelsReport,
  loadingPixelsReport: !!pixelsReportRequestId,
}));

export const selectPixelsEvents = createSelector([selectPixels], ({ pixels, pixelsRequestId }) => ({
  pixels,
  loadingPixels: !!pixelsRequestId,
}));
